import { marketTypes, terms as mdt } from "../constants";
import { cardSettings as activity } from "../constants/dashboards/activity";
import { cardSettings as inventory } from "../constants/dashboards/inventory";
import { cardSettings as prices } from "../constants/dashboards/prices";
import { tabNames } from "../constants/listingViews/overview";

export const settingsByTab = {
    [tabNames.inventory]: inventory,
    [tabNames.prices]: prices,
    [tabNames.activity]: activity,
};

export const getIsValidTimePeriod = (currentTimePeriod, validTimePeriods) => {
    return validTimePeriods.includes(currentTimePeriod);
};

export const getMarketIndicatorType = (countDaysOnMarket) => {
    if (isNaN(countDaysOnMarket)) return;
    const monthsOnMarket = Math.floor(countDaysOnMarket) / 30;
    if (monthsOnMarket < 4) return marketTypes.sellers;
    if (monthsOnMarket >= 4 && monthsOnMarket <= 6) return marketTypes.neutral;
    return marketTypes.buyers;
};

export const getMarketIndicatorContent = (countDaysOnMarket) => {
    const marketType = getMarketIndicatorType(countDaysOnMarket);
    return { title: mdt.getMarketTypeText(mdt[marketType]), description: mdt[`${marketType}MarketDescription`] };
};
